import { Skeleton } from '@/components/ui/skeleton';

export default function FileCardSkeleton() {
  return (
    <div className={'border-border-primary bg-background flex w-full flex-col items-center gap-2 rounded-2xl border p-2'}>
      <div className="inline-flex w-full items-center gap-2">
        <Skeleton className={'size-10 shrink-0 rounded-sm'} />
        <div className={'w-full'}>
          <Skeleton className={'h-3 w-14 rounded-md'} />
        </div>
      </div>
      <div className="border-border-primary h-24 w-full rounded-sm border" />
    </div>
  );
}
